import { usePepI18n } from "../../i18n/usePepI18n";
import type { PepLocale } from "../../i18n/types";

const LOCALES: { id: PepLocale; label: string }[] = [
  { id: "fr", label: "FR" },
  { id: "en", label: "EN" },
];

export function LanguageSwitcher({ variant = "default" }: { variant?: "default" | "compact" }) {
  const { locale, setLocale } = usePepI18n();

  if (variant === "compact") {
    return (
      <div className="pep-lang-switch" role="group" aria-label="Language">
        {LOCALES.map((entry) => (
          <button
            key={entry.id}
            type="button"
            className={`pep-lang-switch__btn${locale === entry.id ? " is-active" : ""}`}
            onClick={() => setLocale(entry.id)}
            aria-pressed={locale === entry.id}
          >
            {entry.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="btn-group" role="group" aria-label="Language">
      {LOCALES.map((entry) => (
        <button
          key={entry.id}
          type="button"
          className={`btn btn-sm ${locale === entry.id ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setLocale(entry.id)}
          aria-pressed={locale === entry.id}
        >
          {entry.label}
        </button>
      ))}
    </div>
  );
}
